import React, { Component } from 'react';
import { Context } from 'context';
import PropTypes from 'prop-types';

import Star from 'components/star/Star'

import styles from './Map.module.scss';
import CodeLabel from "components/codeLabel/CodeLabel";

class Map extends Component {
    static propTypes = {
        map: PropTypes.object.isRequired
    };

    static contextType = Context;

    state = {
        cursorPosition: {
           x: null,
           y: null
        }
    };

    /**
     * Update state with the current cursor position
     * @param event
     */
    setCursorPosition = (event) => {

        const infoHeight = this.info.clientHeight;
        const windowHeight = window.innerHeight;
        let y = event.clientY;

        if(y + infoHeight > windowHeight) y = windowHeight - infoHeight;

        this.setState({
            cursorPosition: {
                x: event.clientX,
                y
            }
        })
    };

    /**
     * Bring this map to the front of the others if it is already open
     */
    setMapSelected = () => {
        this.context.setSelectedWindow(this.props.map.id)
    };

    /**
     * Favourite the map and stop the click from propagating (opening the map)
     */
    toggleMapFavourited = (event) => {
        event.stopPropagation();
        this.context.toggleMapFavourited(this.props.map.id);
    };

    render() {

        let type = "";

        switch(this.props.map.type){
            case "3d":
                type = "3D";
                break;
            case "2d":
                type = "2D";
                break;
            case "single":
                type = "Single Value";
                break;
            default:
                type = "";
                break;
        }

        const open = this.context.windows.some(window => window.mapId === this.props.map.id)

        return (
            <>
                <div
                    className={`${styles.map} ${open ? styles.open : null} dark`}
                    onMouseMove={this.setCursorPosition}
                    onClick={this.context.openWindow.bind(this, this.props.map.id)}
                >
                    <Star modified={this.props.map.swModified} favourited={this.props.map.favourited} onClick={this.toggleMapFavourited}/>
                    <div className={styles.description}>
                        <CodeLabel className={`${styles.label} ${this.props.map.swModified ? styles.modified : "ungrouped"}`} code={this.props.map.title}/>
                        <p className="txtSecondary" onClick={open ? this.setMapSelected : this.context.openWindow.bind(this, this.props.map.id)}>{this.props.map.titleDescription}</p>
                    </div>
                </div>

                <div className={`bgPrimary highlightSecondary ${styles.info}`} style={{top: this.state.cursorPosition.y + 5, left: this.state.cursorPosition.x + 5}} ref={el => this.info = el}>
                    <p><strong>Code Name:</strong> {this.props.map.title}</p>
                    <p><strong>Description:</strong> {this.props.map.titleDescription}</p>
                    <p><strong>Type:</strong> {type}</p>
                    <p><strong>Size: </strong> {this.props.map.mapSize}</p>
                </div>
            </>
        )        
    }
}

export default Map;
